export default "__VITE_ASSET__Bjcn7v4W__"